import { render, staticRenderFns } from "./SearchBoxAlertsRS.vue?vue&type=template&id=35ce253e&scoped=true&"
import script from "./SearchBoxAlertsRS.vue?vue&type=script&lang=js&"
export * from "./SearchBoxAlertsRS.vue?vue&type=script&lang=js&"
import style0 from "./SearchBoxAlertsRS.vue?vue&type=style&index=0&id=35ce253e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce253e",
  null
  
)

export default component.exports